import { useEffect, useState } from "react";
import api from "../../../services/api";
import {
  FaCog,
  FaTruck,
  FaPercent,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaInstagram,
  FaSave,
  FaShieldAlt,
} from "react-icons/fa";

const FIELD_META = {
  delivery_price: { label: "מחיר משלוח", icon: FaTruck, type: "number", placeholder: "0" },
  vat_rate: { label: "מע״מ (%)", icon: FaPercent, type: "number", placeholder: "18" },
  site_phone: { label: "טלפון", icon: FaPhone, type: "text", placeholder: "05X-XXXXXXX" },
  site_email: { label: "אימייל", icon: FaEnvelope, type: "email", placeholder: "info@example.com" },
  site_whatsapp: { label: "וואטסאפ", icon: FaWhatsapp, type: "text", placeholder: "05X-XXXXXXX" },
  site_address: { label: "כתובת", icon: FaMapMarkerAlt, type: "text", placeholder: "כתובת העסק" },
  site_instagram: { label: "אינסטגרם", icon: FaInstagram, type: "text", placeholder: "https://instagram.com/..." },
};

function SettingsAdmin() {
  const [settings, setSettings] = useState({
    delivery_price: "",
    vat_rate: "18",
    site_phone: "",
    site_email: "",
    site_whatsapp: "",
    site_address: "",
    site_instagram: "",
  });
  const [saving, setSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ type: "", message: "" });

  const token = localStorage.getItem("token");

  useEffect(() => {
    api
      .get("/settings/site")
      .then((res) => {
        setSettings({
          delivery_price: res.data.delivery_price || "",
          vat_rate: res.data.vat_rate || "18",
          site_phone: res.data.site_phone || "",
          site_email: res.data.site_email || "",
          site_whatsapp: res.data.site_whatsapp || "",
          site_address: res.data.site_address || "",
          site_instagram: res.data.site_instagram || "",
        });
      })
      .catch(console.error);
  }, []);

  const handleChange = (e) => {
    setSettings((previous) => ({ ...previous, [e.target.name]: e.target.value }));
  };

  const saveSettings = async () => {
    setSaving(true);
    try {
      await api.put("/settings/site", settings, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSaveStatus({ type: "success", message: "ההגדרות נשמרו בהצלחה" });
    } catch (err) {
      console.log(err);
      setSaveStatus({ type: "error", message: "שמירת ההגדרות נכשלה" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="dashboard-section settings-section">
      <div className="section-title">
        <div className="section-title-main">
          <span className="section-icon"><FaCog /></span>
          <div>
            <h2>הגדרות האתר</h2>
            <p>פרטים שמשפיעים על המידע המוצג ללקוחות באתר</p>
          </div>
        </div>
      </div>

      <div className="settings-layout">
        <div className="admin-settings-grid">
          {Object.entries(FIELD_META).map(([name, meta]) => {
            const Icon = meta.icon;
            const full = name === "site_address" || name === "site_instagram";

            return (
              <label className={`admin-setting-field ${full ? "full" : ""}`} key={name}>
                <span className="setting-label-row">
                  <span className="setting-field-icon"><Icon /></span>
                  <span>{meta.label}</span>
                </span>
                <input
                  type={meta.type}
                  name={name}
                  value={settings[name]}
                  onChange={handleChange}
                  placeholder={meta.placeholder}
                />
              </label>
            );
          })}
        </div>

        <aside className="settings-info-card">
          <span className="settings-info-icon"><FaShieldAlt /></span>
          <h3>שינויים בטוחים ומרוכזים</h3>
          <p>הפרטים כאן משמשים את האתר להצגת דרכי קשר, כתובת, מחיר משלוח ושיעור המע״מ.</p>
          <ul>
            <li>בדקו מספרי טלפון לפני שמירה.</li>
            <li>השתמשו בקישור Instagram מלא.</li>
            <li>מחיר המשלוח מתעדכן ללקוחות באתר.</li>
            <li>המע״מ מוגדר כאחוז הכלול במחיר ולא מתווסף מעל המחיר.</li>
          </ul>
        </aside>
      </div>

      {saveStatus.message && (
        <div
          role="alert"
          style={{
            marginTop: 18,
            padding: "14px 16px",
            borderRadius: 14,
            fontWeight: 700,
            background: saveStatus.type === "success" ? "#ecfdf5" : "#fef2f2",
            color: saveStatus.type === "success" ? "#047857" : "#b91c1c",
          }}
        >
          {saveStatus.message}
        </div>
      )}

      <div className="settings-save-bar">
        <div>
          <strong>סיימתם לערוך?</strong>
          <span>לחצו על שמירה כדי לעדכן את פרטי האתר.</span>
        </div>
        <button className="save-settings-btn" onClick={saveSettings} disabled={saving}>
          <FaSave /> {saving ? "שומר..." : "שמירת הגדרות"}
        </button>
      </div>
    </section>
  );
}

export default SettingsAdmin;
